import type { ReactNode } from "react";
import { Button } from "@/components/base/buttons/button";
import { Dialog, Modal, ModalOverlay } from "@/components/application/modals/modal";
import { X } from "@untitledui/icons";
import { Heading } from "react-aria-components";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: "primary" | "primary-destructive";
  isLoading?: boolean;
}

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "primary",
  isLoading = false,
}: ConfirmationModalProps) {
  return (
    <ModalOverlay isOpen={isOpen} onOpenChange={(open) => !open && !isLoading && onClose()} className="items-center">
      <Modal className="max-w-md">
        <Dialog>
          <div className="bg-white rounded-lg w-full">
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
              <Heading slot="title" level={3} className="text-lg font-semibold text-gray-900">{title}</Heading>
              <Button color="tertiary" size="sm" onClick={onClose} isDisabled={isLoading}>
                <X className="size-5" />
              </Button>
            </div>
            <div className="p-4">
              <div className="text-sm text-gray-600">{message}</div>
            </div>
            <div className="flex gap-3 px-4 py-3 border-t border-gray-200">
              <Button color="secondary" className="flex-1" onClick={onClose} isDisabled={isLoading}>
                {cancelText}
              </Button>
              <Button color={confirmColor} className="flex-1" onClick={onConfirm} isLoading={isLoading}>
                {confirmText}
              </Button>
            </div>
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}